/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GoodsReturnListService = {
  dataSourceConfig(url, params) {
    // var url = "api/GoodsInList";
    return ApiService.createDataSource(url, params);
  },
};

export { GoodsReturnListService };
